export default "__VITE_ASSET__yTic5QIV__"